import React from 'react';
import Navbar from '../../../common/navbar';
import DashboardHeader from './dashBoardHeader';
import ActionCards from './actionCards';
import JobsList from './jobsList';

const Dashboard = () => {
  return (
    <div className="w-full flex flex-col main-background h-screen">
      <Navbar />
      <main className="container flex-1 overflow-y-auto scrollbar-hide w-full mx-auto py-[3rem]">
        <DashboardHeader />
        <ActionCards />
        <div className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-lg px-8 py-6 mt-6 anim-slideUp" style={{ animationDuration: "1.5s" }}>
          <JobsList />
        </div>
      </main>
    </div>
  );
};

export default Dashboard;